module.exports = __webpack_public_path__ + "static/media/261-china.23534712.svg";